import { useContext, useEffect, useState } from "react";

import DateFnsUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import { StoreContext } from "../store";
import Layout from "./Layout";

function Application({ children }) {
  const store = useContext(StoreContext);
  const [routeloading, setRouteLoading] = useState(false);
  const router = useRouter();

  const showNav =
    router.pathname !== "/404" &&
    !!(store.organization.items && store.organization.items.length) &&
    !(router.pathname === "/onboarding" && store.organization.items && store.organization.items.length) &&
    router.pathname !== "/trial-expired";

  // Questionable hook
  useEffect(() => {
    if (store.user.signedIn) {
      store.organization.fetch();
    }
  }, []);

  useEffect(() => {
    const routeChangeStart = (url, { shallow }) => {
      if (!shallow) {
        setRouteLoading(true);
      }
    };
    const routeChangeComplete = (url, { shallow }) => {
      if (!shallow) {
        setRouteLoading(false);
      }
    };

    router.events.on("routeChangeStart", routeChangeStart);
    router.events.on("routeChangeComplete", routeChangeComplete);

    return () => {
      router.events.off("routeChangeStart", routeChangeStart);
      router.events.off("routeChangeComplete", routeChangeComplete);
    };
  }, [router]);

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={store?.organization?.selected?.locale ?? "id"}>
      <Layout showNav={showNav}>{!routeloading && children}</Layout>
    </MuiPickersUtilsProvider>
  );
}

export default observer(Application);
